import lodashCapitalize from 'lodash/capitalize';
import { util } from '@/api/util';
import { getContactLabel, getContactPYLabel } from './common';
const getCurrentDomain = (systemApi) => systemApi.getCurrentUser().domain;
const buildContactItem = (params) => {
    const { id, value, contactItemType, type, isDefault } = params;
    const _lastUpdateTime = Date.now();
    return {
        id: util.getUnique(id, 'MOBILE', value),
        contactId: id,
        contactItemVal: value,
        contactItemType,
        contactItemRefer: '',
        isDefault: isDefault ? 1 : 0,
        type,
        _lastUpdateTime,
    };
};
export const transLocal2ServerCustomerId = (id) => {
    if (id.startsWith('customer_')) {
        return id.split('customer_')[1];
    }
    return id;
};
export const createCustomerId = (id) => {
    return id.startsWith('customer_') ? id : 'customer_' + id;
};
export const createClueId = (id) => {
    return id.startsWith('clue_') ? id : 'clue_' + id;
};
export const createCustomerOrgId = (data, type) => {
    return type.startsWith('customer') ? 'customer_' + data.company_id : 'clue_' + data.id;
};
export const transServerRepToDB = (data, type, lastUpdateTime, options) => {
    const _lastUpdateTime = lastUpdateTime || Date.now();
    const orgList = [];
    let managerList = [];
    let contactList = [];
    let orgContactList = [];
    let contactModelList;
    const idList = [];
    const transToOrgManager = type === 'customer' ? transCustomerToOrgManager : transClueToOrgManager;
    const transToOrg = type === 'customer' ? transCustomerToOrg : transClueToOrg;
    data.forEach(item => {
        var _a;
        const orgId = createCustomerOrgId(item, type);
        idList.push(orgId);
        const hasEmail = !!((_a = item.contact_list) === null || _a === void 0 ? void 0 : _a.some((curContact) => curContact.email));
        if (!item.delFlag && hasEmail) {
            const res = transToContact(item, type, _lastUpdateTime, options);
            contactList = contactList.concat(res.contactList);
            orgContactList = orgContactList.concat(res.orgContactList);
            managerList = managerList.concat(transToOrgManager(item, _lastUpdateTime, options));
            const orgData = transToOrg(item, _lastUpdateTime, options);
            orgList.push(orgData);
        }
    });
    return {
        orgList,
        managerList,
        contactList,
        orgContactList,
        idList,
        contactModelList,
    };
};
export const transCustomerToOrg = (item, _lastUpdateTime, options) => {
    var _a, _b;
    const id = createCustomerId(item.company_id);
    const originId = item.company_id;
    const orgName = item.company_name;
    const orgPYName = util.toPinyin(orgName);
    const createTime = typeof item.create_time === 'number' ? item.create_time : new Date(item.create_time).getTime();
    const managerNames = (_a = item.manager_list) === null || _a === void 0 ? void 0 : _a.map((p) => (p === null || p === void 0 ? void 0 : p.name) || '');
    const labelNames = (_b = item.label_list) === null || _b === void 0 ? void 0 : _b.map((p) => (p === null || p === void 0 ? void 0 : p.label_name) || '');
    return {
        id,
        originId,
        visibleCode: 0,
        orgName,
        orgPYName,
        type: 2002,
        orgRank: createTime || 0,
        createTime,
        parent: 'customer',
        area: Array.isArray(item.area)
            ? item.area.reduce((str, cur) => {
                if (cur) {
                    str = (str ? str + '-' : '') + cur;
                }
                return str;
            }, '')
            : item.area,
        zone: item.zone,
        website: item.website,
        cLevel: item.company_level,
        cLevelName: item.company_level_name,
        number: item.company_number,
        domain: item.company_domain,
        shortName: item.short_name,
        starLevel: item.star_level,
        sourceName: item.source_name,
        companyName: item.company_name,
        labelNames,
        managerNames,
        customerType: 'customer',
        _lastUpdateTime,
        lastUpdateTime: item.lastUpdateTime,
        _company: getCurrentDomain(options.systemApi),
    };
};
export const transClueToOrg = (item, _lastUpdateTime, options) => {
    var _a;
    const id = createClueId(item.id);
    const originId = item.id;
    const orgName = item.company_name || item.name;
    const orgPYName = util.toPinyin(orgName);
    const createTime = typeof item.create_at === 'number' ? item.create_time : new Date(item.create_time).getTime();
    const owner = (_a = item.manager_list) === null || _a === void 0 ? void 0 : _a.map((p) => (p === null || p === void 0 ? void 0 : p.name) || '');
    return {
        id,
        originId,
        visibleCode: 0,
        orgName,
        orgPYName,
        type: 2003,
        orgRank: createTime || 0,
        createTime,
        parent: 'clue',
        number: item.number,
        status: item.status,
        area: item.area,
        website: item.website,
        domain: item.company_domain,
        companyName: item.company_name,
        managerNames: owner,
        sourceName: item.source_name,
        createType: item.create_type,
        customerType: 'clue',
        _lastUpdateTime,
        lastUpdateTime: item.lastUpdateTime,
        _company: getCurrentDomain(options.systemApi),
    };
};
export const transCustomerToOrgLabel = (item, _lastUpdateTime, options) => {
    const labelList = [];
    const orgId = createCustomerId(item.company_id);
    item.label_list.forEach((label) => {
        labelList.push(transToLabel(label, orgId, 'customer', _lastUpdateTime, options));
    });
    return labelList;
};
export const transCustomerToOrgManager = (item, _lastUpdateTime, options) => {
    const list = item.manager_list;
    const result = [];
    const orgId = createCustomerId(item.company_id);
    const companyId = getCurrentDomain(options.systemApi);
    list === null || list === void 0 ? void 0 : list.forEach((manager) => {
        const { id: managerId, name: managerName, email: managerAccount, lastSetTopTime = 0, lastMailTime = 0 } = manager;
        result.push({
            id: util.getUnique(orgId, managerId),
            orgId,
            managerName,
            managerId,
            managerAccount,
            companyId,
            customerType: 'customer',
            _lastUpdateTime,
            _company: getCurrentDomain(options.systemApi),
            lastUpdateTime: item.lastUpdateTime,
            lastSetTopTime,
            lastMailTime,
            sortWeight: -(lastSetTopTime * 5 + lastMailTime * 2 + Number(item.company_id || 0)),
        });
    });
    return result;
};
export const transClueToOrgManager = (item, _lastUpdateTime, options) => {
    const list = item.manager_list;
    const result = [];
    const orgId = createClueId(item.id);
    const companyId = getCurrentDomain(options.systemApi);
    list.forEach((manager) => {
        const { id: managerId, name: managerName, email: managerAccount, lastSetTopTime = 0, lastMailTime = 0 } = manager;
        result.push({
            id: util.getUnique(orgId, managerId),
            orgId,
            managerName,
            managerId,
            managerAccount,
            companyId,
            customerType: 'clue',
            _lastUpdateTime,
            _company: getCurrentDomain(options.systemApi),
            lastUpdateTime: item.lastUpdateTime,
            lastSetTopTime,
            lastMailTime,
            sortWeight: -(lastSetTopTime * 5 + lastMailTime * 2 + Number(item.id || 0)),
        });
    });
    return result;
};
export const transToContact = (data, type, _lastUpdateTime, options) => {
    var _a;
    const contactList = [];
    const orgContactList = [];
    const orgId = type.startsWith('customer') ? createCustomerId(data.company_id) : createClueId(data.id);
    const _company = getCurrentDomain(options.systemApi);
    (_a = data.contact_list) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
        var _a;
        const originId = item.contact_id;
        const name = item.contact_name;
        const contactPYName = util.toPinyin(name);
        const contactLabel = getContactLabel(contactPYName);
        const contactPYLabelName = getContactPYLabel(name);
        const account = (_a = item.email) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase();
        const contactId = item.contact_id;
        orgContactList.push({
            id: util.getUnique(orgId, contactId),
            account,
            orgId,
            contactId,
            isMainContact: Boolean(item.main_contact),
            _lastUpdateTime,
            customerType: type,
            _company,
        });
        contactList.push({
            id: contactId,
            contactLabel,
            contactPYName,
            contactPYLabelName,
            name,
            account,
            originId,
            customerType: type,
            avatar: item.contact_icon,
            remark: item.remark,
            whatsApp: item.whats_app,
            phones: item.phones,
            gender: item.gender,
            birthday: item.birthday,
            homePage: item.homePage,
            job: item.job,
            pictures: item.pictures,
            _lastUpdateTime,
            _company,
        });
    });
    return {
        contactList,
        orgContactList,
    };
};
export const transToLabel = (label, parentId, customerType, _lastUpdateTime, options) => {
    const { label_id: originId = '', label_name: name = '', label_color: color = '', label_create_time: createTime = 0, label_type: type = 0 } = label;
    const _company = getCurrentDomain(options.systemApi);
    const item = {
        id: util.getUnique(parentId, originId),
        originId,
        name,
        color,
        type,
        createTime,
        customerType,
        _lastUpdateTime,
        _company,
    };
    if (customerType === 'customer' || customerType === 'clue') {
        item.orgId = parentId;
    }
    else if (customerType === 'customer_contact' || customerType === 'clue_contact') {
        item.contactId = parentId;
    }
    return item;
};
export const transClueToContact = (item) => {
    const id = createClueId(item.id);
    const contactName = item.contact_name;
    const contactPYName = util.toPinyin(contactName);
    const contactLabel = getContactLabel(contactPYName);
    const contactPYLabelName = getContactPYLabel(contactName);
    const accountName = item.email;
    const accountId = item.contact_id;
    const _lastUpdateTime = Date.now();
    return {
        id,
        contactLabel,
        contactPYName,
        contactPYLabelName,
        contactName,
        accountName,
        accountId,
        visibleCode: 0,
        type: 'customer',
        accountType: 2,
        displayEmail: accountName,
        enableIM: false,
        avatar: item.contact_icon,
        remark: item.remark,
        _lastUpdateTime,
    };
};
export const transColleagueToUnitContact = (item, _lastUpdateTime) => {
    const res = [];
    const contactId = item.accId;
    res.push({
        id: contactId,
        contactId,
        orgId: util.getUnique((item === null || item === void 0 ? void 0 : item.unitIds) || []),
        email: item.email,
        nickname: item.nickname,
        status: item.status,
        _lastUpdateTime,
    });
    return res;
};
export const getCustomerContactIdList = (data, type) => {
    var _a;
    const contactList = [];
    const orgContactList = [];
    const orgId = type.startsWith('customer') ? createCustomerId(data.company_id) : createClueId(data.id);
    (_a = data.contact_list) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
        const contactId = item.contact_id;
        contactList.push(contactId);
        orgContactList.push(util.getUnique(orgId, contactId));
    });
    return {
        contactList,
        orgContactList,
    };
};
export const getCustomerManagerIdList = (data, type) => {
    const list = data.manager_list;
    const result = [];
    const orgId = type.startsWith('customer') ? createCustomerId(data.company_id) : createClueId(data.id);
    list === null || list === void 0 ? void 0 : list.forEach((manager) => {
        result.push(util.getUnique(orgId, manager.id));
    });
    return result;
};
export const transCustomerToContactModel = (item) => {
    const { id, contactLabel, contactPYName, name, contactPYLabelName, avatar, account, remark, customerType, originId, phones, whatsApp = '', _lastUpdateTime } = item;
    const type = customerType.startsWith('customer') ? 'customer' : 'clue';
    const contactInfo = [
        buildContactItem({
            id,
            value: whatsApp,
            contactItemType: 'whatsApp',
            type,
        }),
        buildContactItem({
            id,
            type,
            contactItemType: 'EMAIL',
            value: account,
            isDefault: true,
        }),
    ];
    phones === null || phones === void 0 ? void 0 : phones.forEach((value) => {
        contactInfo.push(buildContactItem({
            id,
            value,
            type,
            contactItemType: 'MOBILE',
        }));
    });
    return {
        contact: {
            id,
            contactLabel,
            contactPYName,
            contactPYLabelName,
            contactName: name,
            avatar,
            accountType: 2,
            displayEmail: account,
            accountName: account,
            remark,
            type,
            visibleCode: 0,
            enableIM: false,
            accountId: originId,
            color: util.getColor(account),
            _lastUpdateTime,
        },
        contactInfo,
    };
};
export const transCustomerRole2EmailRole = (type, role) => {
    if (!role) {
        return role;
    }
    const lxType = ['enterprise', 'personal', 'external'];
    if (lxType.includes(type)) {
        return type;
    }
    if (role === 'manager') {
        return ('my' + lodashCapitalize(type));
    }
    return (role + lodashCapitalize(type));
};
export const transEmailRole2CustomerRole = (role) => {
    return role;
};
